import { Box } from '@mui/material';

interface JsonViewerProps {
  data: any;
}

export default function JsonViewer({ data }: JsonViewerProps) {
  return (
    <Box sx={{ 
      p: 2, 
      bgcolor: 'background.paper', 
      borderRadius: 1,
      overflow: 'auto',
      maxHeight: '500px'
    }}>
      <pre style={{ 
        margin: 0,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        fontFamily: 'monospace',
        fontSize: '14px'
      }}>
        {JSON.stringify(data, null, 2)}
      </pre>
    </Box>
  );
} 